module.exports = __webpack_public_path__ + "img/advantage5.2e652944.png";